<template>
  <el-dialog title="安装费用管理" :visible.sync="dialogVisible" fullscreen @close="dialogClose" modal-append-to-body>
    <div class="cost_management">
      <div class="cost_management_query">
        <el-form :inline="true" :model="costManagementParams" style="
            padding-top: 20px;
            padding-left: 20px;
            margin-bottom: 20px;
            background-color: #fff;
            border-radius: 8px;
          " size="small">
          <el-form-item label="所属公司">
            <el-select multiple filterable v-model="costManagementParams.queryCompanyList" placeholder="请选择所属公司">
              <el-option v-for="item in companyDrownList" :key="item.companyId" :label="item.companyManager"
                :value="item.companyId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属品牌">
            <el-select multiple filterable v-model="costManagementParams.queryDeviceBrandIdList" placeholder="请选择">
              <el-option v-for="item in deviceBrandDrownList" :key="item.id" :label="item.brandName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="query">查询</el-button>
            <el-button type="info" size="mini" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="cost_management_table">
        <div class="cost_management_btn">
          <el-button type="success" size="small" @click="copy" v-show="authorization(
            '/home-admin/routineManage/user-list/install-fee-manage/add'
          )" style="
              float: right;
              margin-top: 10px;
              margin-right: 20px;
              margin-bottom: 10px;
            ">复制</el-button>
        </div>
        <div class="cost_management_btn">
          <el-button type="warning" size="small" v-show="authorization(
            '/home-admin/routineManage/user-list/install-fee-manage/edit'
          )" style="
              float: right;
              margin-top: 10px;
              margin-right: 20px;
              margin-bottom: 10px;
            " @click="batchupdate">批量修改费用</el-button>
        </div>
        <div class="cost_management_btn">
          <el-button type="primary" size="small" style="
              float: right;
              margin-top: 10px;
              margin-right: 20px;
              margin-bottom: 10px;
            " @click="
              showDialog('add')" v-show="authorization(
                '/home-admin/routineManage/user-list/install-fee-manage/add'
              )">新增</el-button>
        </div>
        <div class="cost_management_btn">
          <el-button type="primary" size="small" style="
              float: right;
              margin-top: 10px;
              margin-right: 20px;
              margin-bottom: 10px;
            " @click="showDialog('batchAdd')" v-show="authorization(
              '/home-admin/routineManage/user-list/install-fee-manage/add'
            )">批量新增</el-button>
        </div>
        <el-table :data="costManagementTableData" stripe border style="margin-left: 20px; width: 98%" size="small"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }" :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectionChange"
          v-loading="tableLoading">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in costManagementTable" :key="index" :prop="item.prop"
            :label="item.label" show-overflow-tooltip :width="item.width">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip v-show="authorization(
                '/home-admin/routineManage/user-list/install-fee-manage/edit'
              )
                " effect="dark" content="编辑" placement="top-end">
                <el-button type="primary" icon="el-icon-edit" circle size="mini"
                  style="margin-right: 5px; margin-left: 5px" @click="handleEdit(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" v-show="authorization(
                '/home-admin/routineManage/user-list/install-fee-manage/del'
              )
                " content="删除" placement="top-end">
                <el-popconfirm title="确认删除吗？" @confirm="deleteData(scope.row)">
                  <el-button content="删除" slot="reference" type="danger" icon="el-icon-delete" circle
                    size="mini"></el-button>
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div style="
            padding-top: 20px;
            height: 40px;
            background-color: #fff;
            width: 100%;
            border-radius: 8px;
            text-align: right;
          ">
          <el-pagination
            background
            :current-page="page"
            :page-size="size"
            :page-sizes="sizes"
            layout="total,sizes,prev,pager,next"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="sizeChange"
          ></el-pagination>
        </div>
      </div>
      <div>
        <!-- 批量新增 -->
        <el-dialog title="批量新增" :visible.sync="dialogVisibleBatchAdd" append-to-body>
          <el-form ref="formBatch" :model="constManagementFormBatch" :rules="constManagementRules" size="small"
            style="width: 600px; margin-left: 20px" label-width="180px">
            <el-form-item label="所属公司" prop="company">
              <el-select clearable filterable v-model="constManagementFormBatch.company" placeholder="请选择所属公司"
                style="width: 100%">
                <el-option v-for="item in companyDrownList" :key="item.companyId" :label="item.companyManager"
                  :value="String(item.companyId)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属品牌" prop="brand">
              <el-select clearable filterable v-model="constManagementFormBatch.brand" @change="changeBrand"
                placeholder="请选择" style="width: 100%">
                <el-option v-for="item in deviceBrandDrownList" :key="item.id" :label="item.brandName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车型（可多选）" prop="model">
              <el-select clearable filterable style="width: 100%" v-model="constManagementFormBatch.model"
                placeholder="请选择" multiple>
                <el-option v-for="item in allDeviceModelDrownList" :key="item.id"
                  :label="item.modelName + ' | ' + item.brandName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省市区/县（可多选）" prop="fullLocalIdX">
              <el-cascader style="width: 100%" :options="options" clearable :props="addBatchProps"
                v-model="constManagementFormBatch.fullLocalIdX">
              </el-cascader>
            </el-form-item>
            <el-form-item label="安装费用" prop="installationFee">
              <el-input v-model="constManagementFormBatch.installationFee"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
              <el-input type="textarea" maxlength="500" v-model="constManagementFormBatch.remarks"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleBatchAdd = false" size="small">取 消</el-button>
            <el-button type="primary" @click="addSubmitBatch" size="small">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 新增 -->
        <el-dialog :title="addOrEdit ? '编辑' : '新增'" :visible.sync="dialogVisibleEdit" append-to-body
          @close="childDialogClose">
          <el-form ref="form" :model="constManagementForm" :rules="constManagementRules" size="small"
            style="width: 600px; margin-left: 20px" label-width="160px">
            <el-form-item label="所属公司" prop="company">
              <el-select clearable filterable v-model="constManagementForm.company" placeholder="请选择所属公司"
                style="width: 100%">
                <el-option v-for="item in companyDrownList" :key="item.companyId" :label="item.companyManager"
                  :value="String(item.companyId)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属品牌" prop="brand">
              <el-select clearable filterable v-model="constManagementForm.brand" @change="changeBrand"
                placeholder="请选择" style="width: 100%">
                <el-option v-for="item in deviceBrandDrownList" :key="item.id" :label="item.brandName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车型" prop="model">
              <el-select clearable filterable style="width: 100%" v-model="constManagementForm.model" placeholder="请选择">
                <el-option v-for="item in allDeviceModelDrownList" :key="item.id"
                  :label="item.modelName + ' | ' + item.brandName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省市区/县" prop="fullLocalIdX">
              <el-cascader style="width: 100%" :options="options" :props="{ value: 'label', children: 'children' }"
                v-model="constManagementForm.fullLocalIdX">
              </el-cascader>
            </el-form-item>
            <el-form-item label="安装费用" prop="installationFee">
              <el-input v-model="constManagementForm.installationFee"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
              <el-input type="textarea" maxlength="500" v-model="constManagementForm.remarks"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="childDialogClose" size="small">取 消</el-button>
            <el-button type="primary" @click="addSubmit" size="small">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 批量修改费用 -->
      <el-dialog title="批量修改费用" :visible.sync="dialogVisibleBatch" append-to-body @close="batchDialogClose">
        <el-form :model="editFormBatch" ref="batchForm" :rules="editFormBatchRules" label-width="160px" size="small"
          style="width: 600px; margin-top: 30px">
          <el-form-item label="费用:" prop="installationFee">
            <el-input v-model="editFormBatch.installationFee" placeholder="请输入安装费用"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="batchDialogClose" size="small">取 消</el-button>
          <el-button type="primary" @click="batchSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
import { costManagementTable } from "./userList";
import { regionData } from "element-china-area-data";
import { authorization } from "../../../authorization/authorization";
import { validateNumber } from "@/utils/index";
export default {
  props: ["costManagementVisible", "userId"],
  data() {
    return {
      addBatchProps: {
        value: 'label',
        children: 'children',
        multiple: true,   // 关键点：禁用非叶子节点
        disabled: (data, node) => {
          return true // 只有叶子节点（最后一级）可选
        }
      },
      costManagementTableData: [],
      costManagementTable: costManagementTable,
      costManagementParams: {
        queryDeviceBrandIdList: [],
        queryCompanyList: [],
      },
      costManagementSelecttable: [],
      dialogVisible: false,
      dialogVisibleEdit: false,
      constManagementForm: {
        installationFee: "",
        company: "",
        brand: "",
        model: "",
        fullLocalIdX: [],
        remarks: "",
      },
      constManagementFormBatch: {
        installationFee: "",
        company: "",
        brand: "",
        model: [],
        fullLocalIdX: [],
        remarks: "",
      },
      constManagementRules: {
        installationFee: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
        company: [
          { required: true, message: "请选择所属公司", trigger: "change" },
        ],
        brand: [
          { required: true, message: "请选择所属品牌", trigger: "change" },
        ],
        model: [{ required: true, message: "请选择车型", trigger: "change" }],
        fullLocalIdX: [
          { required: true, message: "请选择省市区/县", trigger: "change" },
        ],
      },
      companyDrownList: [],
      deviceBrandDrownList: [],
      allDeviceModelDrownList: [],
      options: regionData,
      total: 0,
      sizes: [10, 15, 20, 50],
      page: 1,
      size: 10,
      addOrEdit: false,
      tableLoading: false,
      dialogVisibleBatch: false,
      dialogVisibleBatchAdd: false,
      editFormBatch: {
        installationFee: "",
      },
      editFormBatchRules: {
        installationFee: [
          { required: true, message: "请输入费用", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    costManagementVisible(newVal) {
      this.dialogVisible = newVal;
      this.getCompanyDrown();
      this.queryDeviceBrandDrown();
      // this.queryDeviceModelDrown();
      this.query();
    },
  },
  methods: {
    authorization,
    showDialog(type) {
      if (type === "batchAdd") {
        this.constManagementFormBatch = {
          installationFee: "",
          company: "",
          brand: "",
          model: [],
          fullLocalIdX: [],
          remarks: "",
        };
        this.allDeviceModelDrownList = [];
        this.dialogVisibleBatchAdd = true;
        this.$nextTick(() => {
          if (this.$refs.formBatch) {
            this.$refs.formBatch.clearValidate();
          }
        });
      } else if (type === "add") {
        this.addOrEdit = false;
        this.dataId = undefined;
        this.resetConstManagementForm();
        this.allDeviceModelDrownList = [];
        this.dialogVisibleEdit = true;
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        });
      }
    },
    changeBrand(value) {
      const brandId =
        value !== undefined && value !== null && value !== ""
          ? value
          : this.constManagementForm.brand;
      const find = this.deviceBrandDrownList.find((e) => e.id == brandId);
      this.allDeviceModelDrownList =
        find && find.modelList ? [...find.modelList] : [];
      if (find) {
        this.allDeviceModelDrownList.forEach((item) => {
          item.brandName = find.brandName;
        });
      }
      this.constManagementForm.model = "";
      this.constManagementFormBatch.model = [];
    },
    fillModelListByBrand(brandId) {
      const find = this.deviceBrandDrownList.find((e) => e.id == brandId);
      this.allDeviceModelDrownList =
        find && find.modelList ? [...find.modelList] : [];
      if (find) {
        this.allDeviceModelDrownList.forEach((item) => {
          item.brandName = find.brandName;
        });
      }
    },
    resetConstManagementForm() {
      this.constManagementForm = {
        installationFee: "",
        company: "",
        brand: "",
        model: "",
        fullLocalIdX: [],
        remarks: "",
      };
    },
    buildConstManagementForm(row) {
      return {
        installationFee: row.installationFee,
        company:
          row.companyId !== undefined && row.companyId !== null
            ? String(row.companyId)
            : "",
        brand: row.brandId,
        model: row.modelId,
        fullLocalIdX: [row.provinceName, row.cityName, row.areaName],
        remarks: row.remarks || "",
      };
    },
    copy() {
      if (this.costManagementSelecttable.length == 0) {
        this.$message.warning("请先选择要复制的列表数据！");
        return;
      }
      if (this.costManagementSelecttable.length > 1) {
        this.$message.warning("只能选择一条数据进行复制");
        return;
      }
      const row = this.costManagementSelecttable[0];
      this.addOrEdit = false;
      this.dataId = undefined;
      // 先按品牌刷新车型下拉，避免沿用上一次的车型缓存
      this.fillModelListByBrand(row.brandId);
      this.constManagementForm = this.buildConstManagementForm(row);
      this.dialogVisibleEdit = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    handleSelectionChange(val) {
      this.costManagementSelecttable = val;
    },
    dialogClose() {
      this.$emit("update:costManagementVisible", false);
    },
    handleEdit(data) {
      this.fillModelListByBrand(data.brandId);
      this.constManagementForm = this.buildConstManagementForm(data);
      this.dataId = data.id;
      this.addOrEdit = true;
      this.dialogVisibleEdit = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    getCompanyDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/company-manager/select-company-drown",
      }).then((res) => {
        this.companyDrownList = res.data.data;
      });
    },
    queryDeviceBrandDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/device-brand/select-business-brands",
      }).then((res) => {
        this.deviceBrandDrownList = res.data.data.list;
      });
    },
    // queryDeviceModelDrown() {
    //   this.axios({
    //     method: "get",
    //     url: "/v1/web/device-brand/select-device-model",
    //   }).then((res) => {
    //     this.allDeviceModelDrownList = res.data.data.list;
    //   });
    // },
    query(index) {
      if (!index) {
        this.page = 1;
      }
      this.tableLoading = true;
      const data = {
        page: this.page,
        size: this.size,
        companyIds: this.costManagementParams.queryCompanyList.join(","),
        brandIds: this.costManagementParams.queryDeviceBrandIdList.join(","),
        userId: this.userId,
      };
      this.axios({
        method: "post",
        url: "/v1/web/routine-manage/user-list/install-fee-manage/list",
        data: data,
      })
        .then((res) => {
          this.costManagementTableData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    reset() {
      this.costManagementParams.queryCompanyList = [];
      this.costManagementParams.queryDeviceBrandIdList = [];
      this.query();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.query(1);
    },
    sizeChange(val) {
      this.size = val;
      this.query(1);
    },
    deleteData(data) {
      this.axios({
        method: "DELETE",
        url: `/v1/web/routine-manage/user-list/install-fee-manage/del/${data.id}`,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.query(1);
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    addSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = {
            areaName: this.constManagementForm.fullLocalIdX[2],
            brandId: this.constManagementForm.brand,
            cityName: this.constManagementForm.fullLocalIdX[1],
            companyId: this.constManagementForm.company,
            installationFee: this.constManagementForm.installationFee,
            modelId: this.constManagementForm.model,
            provinceName: this.constManagementForm.fullLocalIdX[0],
            remarks: this.constManagementForm.remarks,
            userId: this.userId,
          };
          if (this.addOrEdit) {
            this.edit(data, this.dataId);
          } else {
            this.add(data);
          }
        } else {
          return false;
        }
      });
    },
    addSubmitBatch() {
      this.$refs.formBatch.validate((valid) => {
        if (valid) {
          const data = {
            places: this.constManagementFormBatch.fullLocalIdX,
            brandId: this.constManagementFormBatch.brand,
            companyId: this.constManagementFormBatch.company,
            installationFee: this.constManagementFormBatch.installationFee,
            modelIds: this.constManagementFormBatch.model,
            remarks: this.constManagementFormBatch.remarks,
            userId: this.userId,
          };
          console.log("🚀 ~ this.$refs.formBatch.validate ~ data:", data)
          this.axios({
            method: "post",
            url: "/v1/web/routine-manage/user-list/install-fee-manage/batch-add",
            data: data,
          })
            .then((res) => {
              if (res.data.code === 200) {
                if (!res.data.data) {
                  this.$message({
                    message: "新增成功",
                    type: "success",
                  });

                } else {
                  const successCount = res.data.data.successCount || 0;
                  const errorList = res.data.data.errorList || [];
                  this.$message({
                    message: `新增成功${successCount}条，失败${errorList.length}条`,
                    type: "success",
                  });

                  setTimeout(() => {
                    if (errorList.length > 0) {
                      let msg = ''
                      errorList.forEach((item) => {
                        msg += '<p style="line-height: 22px;">' + item + '</p>'
                      })
                      this.$message({
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                        message: msg,
                        duration: 0,
                        showClose: true
                      });
                    }
                  }, 2000);
                }
                this.query();
                this.dialogVisibleBatchAdd = false;
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.dialogVisibleEdit = false;
            });
        } else {
          return false;
        }
      });
    },
    add(data) {
      this.axios({
        method: "post",
        url: "/v1/web/routine-manage/user-list/install-fee-manage/add",
        data: data,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.query();
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.dialogVisibleEdit = false;
        });
    },
    edit(data, id) {
      this.axios({
        method: "post",
        url: `/v1/web/routine-manage/user-list/install-fee-manage/edit/${id}`,
        data: data,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.query();
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.dialogVisibleEdit = false;
        });
    },
    childDialogClose() {
      this.resetConstManagementForm();
      this.allDeviceModelDrownList = [];
      this.dataId = undefined;
      this.addOrEdit = false;
      this.dialogVisibleEdit = false;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    batchupdate() {
      if (this.costManagementSelecttable.length > 0) {
        this.dialogVisibleBatch = true;
      } else {
        this.$message.warning("请先选择要修改的列表数据！");
      }
    },
    batchDialogClose() {
      this.$refs.batchForm.resetFields();
      this.dialogVisibleBatch = false;
    },
    batchSubmit() {
      this.$refs.batchForm.validate((valid) => {
        if (valid) {
          const ids = [];
          this.costManagementSelecttable.forEach((item) => {
            ids.push(item.id);
          });
          this.axios({
            method: "post",
            url: "/v1/web/routine-manage/user-list/install-fee-manage/batch-update",
            data: {
              ids: ids,
              installationFee: this.editFormBatch.installationFee,
            },
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.query();
              this.dialogVisibleBatch = false;
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
              this.dialogVisibleBatch = false;
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.cost_management {
  padding: 20px;
  background-color: rgb(238, 238, 238);
}

.cost_management_table {
  min-height: 500px;
  height: 100%;
  padding: 10px 20px 20px 10px;
  background-color: #fff;
  border-radius: 8px;
}

::v-deep .el-dialog__body {
  padding-top: 0px;
}
</style>
